module.exports = __webpack_public_path__ + "img/color_winter_clothes.ed015453.png";